function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import configDefault from './configDefault.json';
var config = {};
var configLocal = window.APEXWebConfig || {};
// Reliably confirms that x is an Object, but not a Function, Array, etc.
var isObject = function isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};
for (var key in configDefault) {
  if (isObject(configDefault[key]) && isObject(configLocal[key])) {
    config[key] = Object.assign({}, configDefault[key], configLocal[key]);
  } else {
    config[key] = configDefault[key];
  }
}
var _ref = JSON.parse(localStorage.getItem('apexTemplate')) || {},
  localChart = _ref.chart,
  localConfig = _objectWithoutProperties(_ref, ['chart']);
export var assignConfigWithLocal = function assignConfigWithLocal() {
  config.global = Object.assign({}, config.global, localConfig);
  config.TradingLayout.chart = localChart || config.TradingLayout.chart;
};
assignConfigWithLocal();
export default config;